import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { breadcrumbSchema } from "./Seo";

export const Breadcrumbs = ({ crumbs }) => (
  <nav className="mx-auto flex max-w-7xl flex-wrap items-center gap-1.5 px-6 pt-8 text-xs text-slate-500 lg:px-8" data-testid="breadcrumbs">
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(breadcrumbSchema([{ label: "Home", to: "/" }, ...crumbs]))}</script>
    </Helmet>
    <Link to="/" className="font-semibold hover:text-[#4687FF]">Home</Link>
    {crumbs.map((c, i) => (
      <span key={i} className="flex items-center gap-1.5">
        <ChevronRight size={12} />
        {c.to && i < crumbs.length - 1 ? (
          <Link to={c.to} className="font-semibold hover:text-[#4687FF]">{c.label}</Link>
        ) : (
          <span className="text-slate-700">{c.label}</span>
        )}
      </span>
    ))}
  </nav>
);
